export default __webpack_public_path__ + "images/4eecaa33218a99162592c9abe241edec.svg";